import { withDependencies } from '@wix/thunderbolt-ioc'
import { BrowserWindow, BrowserWindowSymbol, IAppDidMountHandler } from '@wix/thunderbolt-symbols'

/**
 * This feature closes the welcome screen in mobile once site is interactive
 */
const welcomeScreenFactory = (window: NonNullable<BrowserWindow>): IAppDidMountHandler => {
	return {
		async appDidMount() {
			if (window.requestCloseWelcomeScreen) {
				window.requestCloseWelcomeScreen()
			}
		},
	}
}

export const WelcomeScreen = withDependencies([BrowserWindowSymbol], welcomeScreenFactory)
